"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var detect_node_es_1 = require("detect-node-es");
exports.env = {
    isNode: detect_node_es_1.isNode,
    forceCache: false,
};



//////////////////
// WEBPACK FOOTER
// ./~/use-sidecar/dist/es5/env.js
// module id = 750
// module chunks = 0